import {
  faDna,
  faGlobe,
  faGraduationCap,
  faMars,
  faSmoking,
  faVenus,
  faWeightScale,
  faWineGlass,
} from "@fortawesome/free-solid-svg-icons";
import drug from "../img/pills.svg";
import symptom from "../img/symptom.svg";
import survey from "../img/survey.png";
import {Consts} from "../../components/pages/consts";

export const intakeFrequencyUnits = [
  { value: "day(s)", label: "days" },
  { value: "week(s)", label: "weeks" },
];

export const patientParameters = [
  {
    paramName: "gender", // 0
    paramIcon: null,
    paramTitle: "what_is_your_genotypic_sex", // code 35810091
    paramRadios: ["male", "female"], // codes 35820554, 35818840
    paramRadioIcons: [faMars, faVenus],
  },
  {
    paramName: "ethnicity", //1
    paramIcon: faGlobe,
    paramTitle: "your_ethnicity", // code 35811393
    // codes 38003600, 8515, 700391, 38003614, 8522
    paramRadios: [
      "african",
      "asian",
      "mixed_background",
      "white",
      "other_ethnicity",
    ],
    paramRadioIcons: [],
  },
  {
    paramName: "education", //2
    paramIcon: faGraduationCap,
    paramTitle: "your_highest_level_of_education", //code 35810746
    // codes 1620732, 35821787, 35821953, 35817386, 45878298
    paramRadios: [
      "primary_education",
      "secondary_school",
      "vocational",
      "bachelor_college",
      "master_phd",
      "other",
      "prefer_not_to_answer"
    ],
    paramRadioIcons: [],
  },
  {
    paramName: "smoking",
    paramIcon: faSmoking, //3
    paramTitle: "your_smoking_habits", // code 35811013
    paramRadios: ["occasionally_regularly", "never", "previous"], // codes 35817596, 35821337, 35822845
    paramRadioIcons: [],
  },
  {
    paramName: "alcohol", //4
    paramIcon: faWineGlass,
    paramTitle: "your_alcohol_consumption", // code 35811014
    paramRadios: ["occasionally", "never", "previous"], // codes 35817596, 35821337, 35822845
    paramRadioIcons: [],
  },
  {
    paramName: "alcoholFrequency", //5
    paramIcon: faWineGlass,
    paramTitle: "frequency_of_your_alcohol_consumption", // code 35810226
    // codes: 35817657, 35821820, 35824290, 35821830
    paramRadios: [
      "daily_or_almost_daily",
      "three_or_four_times_a_week",
      "once_or_twice_a_week",
      "one_or_three_times_a_month",
    ],
    paramRadioIcons: [],
  },
  {
    paramName: "weightHeight", //6
    paramIcon: faWeightScale,
    paramTitle: "what_is_your_approximate_weight_and_height", // codes 35811395 and 35810116
    paramRadios: [],
    paramRadioIcons: [],
  },
  {
    paramName: "diseases", //7
    paramIcon: null,
    paramTitle: "please_select_a_disease_category",
    paramRadios: [],
    paramRadioIcons: [],
  },
  {
    paramName: "pgx", //8
    paramIcon: faDna,
    paramTitle: "have_you_done_a_pharmacogenetic_test",
    paramRadios: ["yes", "no"],
    paramRadioIcons: [],
  },
  {
    paramName: "pgxGenes", //9
    paramIcon: null,
    paramTitle: "",
    paramRadios: [],
    paramRadioIcons: [],
  },
  {
    paramName: "pgxSelectedGenes", //10
    paramIcon: null,
    paramTitle: "specify_details_for_your_selected_genes",
    paramRadios: [],
    paramRadioIcons: [],
  },
  {
    paramName: "drugs", //11
    paramIcon: null,
    paramTitle: "please_enter_your_medicines",
    paramRadios: [],
    paramRadioIcons: [],
  },
  {
    paramName: "summary", //12
    paramIcon: null,
    paramTitle: "thank_you_for_providing_your_initial_data",
    paramRadios: [],
    paramRadioIcons: [],
  },
];

export const homeElems = [
  {
    link: "/drugsTab/",
    elemName: "medication_plan",
    elemText: "medication_plan_info",
    src: drug,
    alt: "drug",
  },
  {
    link: "/symptoms/",
    elemName: "symptoms",
    elemText: "symptoms_info",
    src: survey,
    alt: "symptoms",
  },
  {
    link: "/pdir/",
    elemName: "medication_information",
    elemText: "medication_information_info",
    src: symptom,
    alt: "symptom",
  },
];

export const intakeDosageUnits = [
  { value: { dosageUnit: "tablets" }, label: "tablets" },
  { value: { dosageUnit: "capsules" }, label: "capsules" },
  { value: { dosageUnit: "drops" }, label: "drops" },
  { value: { dosageUnit: "ampules" }, label: "ampules" },
  { value: { dosageUnit: "units" }, label: "units" },
  { value: { dosageUnit: "pieces" }, label: "pieces" },
  { value: { dosageUnit: "teaspoons" }, label: "teaspoons" },
  { value: { dosageUnit: "tablespoons" }, label: "tablespoons" },
  { value: { dosageUnit: "packets" }, label: "packets" },
  { value: { dosageUnit: "suppositories" }, label: "suppositories" },
  { value: { dosageUnit: "patches" }, label: "patches" },
  { value: { dosageUnit: "other" }, label: "other" },
];

export const strengthUnits = [
  { value: { strengthUnit: "g" }, label: "gram" },
  { value: { strengthUnit: "mg" }, label: "milligram" },
  { value: { strengthUnit: "µg" }, label: "microgram" },
  { value: { strengthUnit: "ml" }, label: "milliliter" },
  { value: { strengthUnit: "other" }, label: "other" },
];

export const phenotypeOptions = [
  "ultrarapid_metabolizer",
  "rapid_metabolizer",
  "intermediate_metabolizer",
  "normal_metabolizer",
  "poor_metabolizer",
  "poor_function",
  "normal_function",
  "intermediate_function",
  "heterozygote_expresser",
  "homozygote_expresser",
  "not_specified",
  "other"
];

export const DEFAULT_PAT_GENES = [
  // TODO
  {
    geneName: "CYP2C9",
    genotype: "",
    phenotype: "",
    phenoRisks: [],
    genoRisks: [],
    risks: [],
  },
  {
    geneName: "CYP2C19",
    genotype: "",
    phenotype: "",
    phenoRisks: [],
    genoRisks: [],
    risks: [],
  },
  {
    geneName: "CYP2D6",
    genotype: "",
    phenotype: "",
    phenoRisks: [],
    genoRisks: [],
    risks: [],
  },
  {
    geneName: "SLCO1B1",
    genotype: "",
    phenotype: "",
    phenoRisks: [],
    genoRisks: [],
    risks: [],
  },
];

export const phenotypeMap = {
  "ultrarapid_metabolizer": "Ultrarapid metabolizer",
  "rapid_metabolizer": "Rapid metabolizer",
  "intermediate_metabolizer": "Intermediate metabolizer",
  "normal_metabolizer": "Normal metabolizer",
  "poor_metabolizer": "Poor metabolizer",
  "poor_function": "Poor function",
  "normal_function": "Normal function",
  "intermediate_function": "Intermediate function",
  "heterozygote_expresser": "Heterozygote expresser",
  "homozygote_expresser": "Homozygote expresser",
  "not_specified": "",
  "other": "Other"
}

export const ddiRelevances = {
  "no statement possible": {
    "EN": "no statement possible",
    "DE": "keine Aussage möglich",
    "EL": "καμία δήλωση δεν είναι δυνατή",
    "NL": "geen verklaring mogelijk",
    "SL": "izjava ni možna"
  },
  "no interaction expected": {
    "EN": "no interaction expected",
    "DE": "keine Wechselwirkung zu erwarten",
    "EL": "δεν αναμένεται αλληλεπίδραση",
    "NL": "geen interactie verwacht",
    "SL": "interakcija ni pričakovana"
  },
  "product-specific warning": {
    "EN": "product-specific warning",
    "DE": "produktspezifischer Warnhinweis",
    "EL": "προειδοποίηση για συγκεκριμένο προϊόν",
    "NL": "productspecifieke waarschuwing",
    "SL": "opozorilo za določen izdelek"
  },
  "minor": {
    "EN": "minor",
    "DE": "geringfügig",
    "EL": "ανήλικος",
    "NL": "klein",
    "SL": "manjše"
  },
  "moderate": {
    "EN": "moderate",
    "DE": "mittelschwer",
    "EL": "μέτριος",
    "NL": "matig",
    "SL": "zmerno"
  },
  "severe": {
    "EN": "severe",
    "DE": "schwerwiegend",
    "EL": "αυστηρός",
    "NL": "ernstig",
    "SL": "huda"
  },
  "contraindicated": {
    "EN": "contraindicated",
    "DE": "kontraindiziert",
    "EL": "αντενδείκνυται",
    "NL": "gecontra-indiceerd",
    "SL": "kontraindicirano"
  },
  "not documented in the database": {
    "EN": "not documented in the database",
    "DE": "nicht in der Datenbank dokumentiert",
    "EL": "δεν τεκμηριώνεται στη βάση δεδομένων",
    "NL": "niet gedocumenteerd in de database",
    "SL": "ni dokumentiran v bazi podatkov"
  },
}

export const phenotypeTypes = {
  "intermediate_metabolizer": {
    "EN": "Intermediate metabolizer",
    "DE": "Intermediärer Verstoffwechselung",
    "EL": "Ενδιάμεσος μεταβολιστής",
    "NL": "Intermediair stofwisselaar",
    "SL": "Srednje hiter presnavljalec"
  },
  "normal_metabolizer": {
    "EN": "Normal metabolizer",
    "DE": "Normaler Verstoffwechselung",
    "EL": "Φυσιολογικός μεταβολιστής",
    "NL": "Normale stofwisselaar",
    "SL": "Normalen presnavljalec"
  },
  "poor_metabolizer": {
    "EN": "Poor metabolizer",
    "DE": "Schlechter Verstoffwechselung",
    "EL": "Χαμηλός μεταβολίτης",
    "NL": "Slechte stofwisselaar",
    "SL": "Slab presnavljalec"
  },
  "ultrarapid_metabolizer": {
    "EN": "Ultrarapid metabolizer",
    "DE": "Ultraschnelle Verstoffwechselung",
    "EL": "Υπερταχής μεταβολιστής",
    "NL": "Ultra snelle stofwisselaar",
    "SL": "Ultrahiter presnavljalec"
  },
  "rapid_metabolizer": {
    "EN": "Rapid metabolizer",
    "DE": "Schnelle Verstoffwechselung",
    "EL": "Ταχύς μεταβολιστής",
    "NL": "Snelle stofwisselaar",
    "SL": "Hiter presnavljalec"
  },
  "poor_function": {
    "EN": "Poor function",
    "DE": "Schlechte Funktion",
    "EL": "Κακή λειτουργία",
    "NL": "Slechte functie",
    "SL": "Slabo delovanje"
  },
  "normal_function": {
    "EN": "Normal function",
    "DE": "Normale Funktion",
    "EL": "Κανονική λειτουργία",
    "NL": "Normale functie",
    "SL": "Normalno delovanje"
  },
  "intermediate_function": {
    "EN": "Intermediate function",
    "DE": "Intermediäre Funktion",
    "EL": "Ενδιάμεση λειτουργία",
    "NL": "Intermediaire functie",
    "SL": "Vmesno delovanje"
  },
  "heterozygote_expresser": {
    "EN": "Heterozygote expresser",
    "DE": "Heterozygoter Expresser/Träger",
    "EL": "Ετερόζυγος εκφραστής",
    "NL": "Heterozygote expressor/drager",
    "SL": "Heterozigotni eksprimer/nosilec"
  },
  "homozygote_expresser": {
    "EN": "Homozygote expresser",
    "DE": "Homozygoter Expresser/Träger",
    "EL": "Ομόζυγος εκφραστής",
    "NL": "Homozygote expressor/drager",
    "SL": "Homozigotni eksprimer/nosilec"
  }
}

export const genotypesToSelect = [
  "",
  "1",
  "2",
  "3",
  "4",
  "4A/B",
  "5",
  "6",
  "8",
  "9",
  "10",
  "11",
  "14",
  "17",
  "41",
  "114",
  "1173C>T",
  "XN"
];

export const relevances = {
  "no statement possible": {
    EN: "No assessment from the literature available.",
    DE: "Keine Bewertung aus der Literatur verfügbar.",
    EL: "Δεν υπάρχει διαθέσιμη αξιολόγηση από τη βιβλιογραφία.",
    NL: "Geen beoordeling uit de literatuur beschikbaar.",
    SL: "Ocena iz literature ni na voljo."
  },
  "no interaction expected": {
    EN: "The literature provides indications that no interaction occurs, or no interactions are expected based on the structure/pharmacokinetics/dynamics.",
    DE: "Die Literatur gibt Hinweise darauf, dass keine Wechselwirkung auftritt bzw. aufgrund der Struktur/Pharmakokinetik/Dynamik keine Wechselwirkungen zu erwarten sind.",
    EL: "Η βιβλιογραφία παρέχει ενδείξεις ότι δεν υπάρχει αλληλεπίδραση ή ότι δεν αναμένονται αλληλεπιδράσεις με βάση τη δομή/φαρμακοκινητική/δυναμική.",
    NL: "De literatuur geeft aanwijzingen dat er op basis van de structuur/farmacokinetiek/dynamiek geen interactie optreedt, of dat er geen interacties verwacht worden.",
    SL: "Literatura navaja, da do interakcij ne pride ali pa interakcije niso pričakovane glede na strukturo/farmakokinetiko/dinamiko."
  },
  "product-specific warning": {
    EN: "There are only specific warnings from a pharmaceutical company, usually from the product information",
    DE: "Es gibt nur spezifische Warnhinweise eines Pharmaunternehmens, meist aus den Produktinformationen",
    EL: "Υπάρχουν μόνο συγκεκριμένες προειδοποιήσεις από μια φαρμακευτική εταιρεία, συνήθως από τις πληροφορίες του προϊόντος",
    NL: "Er staan ​​alleen specifieke waarschuwingen van een farmaceutisch bedrijf, meestal uit de productinformatie",
    SL: "Obstajajo samo specifična opozorila farmacevtskega podjetja, običajno iz informacij o izdelku"
  },
  "minor": {
    EN: "The interaction does not necessarily have therapeutic consequences but should be monitored under certain circumstances",
    DE: "Die Wechselwirkung hat nicht unbedingt therapeutische Konsequenzen, sollte aber unter bestimmten Umständen überwacht werden",
    EL: "Η αλληλεπίδραση δεν έχει απαραίτητα θεραπευτικές συνέπειες, αλλά θα πρέπει να παρακολουθείται υπό ορισμένες συνθήκες",
    NL: "De interactie heeft niet noodzakelijkerwijs therapeutische gevolgen, maar moet onder bepaalde omstandigheden worden gecontroleerd",
    SL: "Interakcija nima nujno terapevtskih posledic, ampak jo je kljub temu potrebno (zaželjeno) spremljati pod določenimi pogoji"
  },
  "moderate": {
    EN: "The interaction can lead to therapeutically relevant consequences for the patient",
    DE: "Die Interaktion kann zu therapeutisch relevanten Konsequenzen für den Patienten führen",
    EL: "Η αλληλεπίδραση μπορεί να οδηγήσει σε θεραπευτικά σημαντικές συνέπειες για τον ασθενή",
    NL: "De interactie kan leiden tot therapeutisch relevante gevolgen voor de patiënt",
    SL: "Interakcija ima lahko terapevtsko pomembne posledice za bolnika"
  },
  "severe": {
    EN: "The interaction can potentially be life-threatening or lead to serious, possibly irreversible consequences for the patient",
    DE: "Die Wechselwirkung kann möglicherweise lebensbedrohlich sein oder zu schwerwiegenden, möglicherweise irreversiblen Folgen für den Patienten führen",
    EL: "Η αλληλεπίδραση μπορεί να είναι δυνητικά απειλητική για τη ζωή ή να οδηγήσει σε σοβαρές, πιθανώς μη αναστρέψιμες συνέπειες για τον ασθενή",
    NL: "De interactie kan potentieel levensbedreigend zijn of tot ernstige, mogelijk onomkeerbare gevolgen voor de patiënt leiden",
    SL: "Interakcija lahko predstavlja življenje ogrožujoč dogodek ali vodi v resne, potencialno nepovratne posledice za bolnika"
  },
  "contraindicated": {
    EN: "The interacting agents must not be combined",
    DE: "Die interagierenden Wirkstoffe dürfen nicht kombiniert werden",
    EL: "Οι αλληλεπιδρώντες παράγοντες δεν πρέπει να συνδυάζονται",
    NL: "De interacterende middelen mogen niet worden gecombineerd",
    SL: "Medsebojno delujočih učinkovin se ne sme kombinirati"
  },
  "not documented in the database": {
    EN: "Clinical relevance is not documented in the database",
    DE: "Die klinische Relevanz ist in der Datenbank nicht dokumentiert",
    EL: "Η κλινική συνάφεια δεν τεκμηριώνεται στη βάση δεδομένων.",
    NL: "De klinische relevantie is niet gedocumenteerd in de database",
    SL: "Klinična pomembnost v podatkovni zbirki ni zabeležena"
  }
}

export const defaultDrug = {
  productName: "",
  activeSubstance: "",
  atc: "",
  code: "",
  strength: 0,
  strengthUnit: "",
  frequency: 1,
  frequencyUnit: "day(s)",
  intakeType: Consts.REGULARLY,
  timingType: Consts.DAY_TIMES,
  status: Consts.ACTIVE,
  intakes: Consts.DEFAULT_DAY_TIME_INTAKES
}

export const hospitalLanguages = {
  "Demo-hospital": "en",
  "University Hospital of RWTH Aachen": "de",
  "Universitätsklinikum Heidelberg": "de",
  "Leiden University Medical Center": "nl",
  "Zdravstveni center Ljubljana - VIČ": "sl",
  "Zdravstveni center Ljubljana - BEŽIGRAD": "sl",
  "Ambulanta KUS": "sl",
  "ZZ Zdravje": "sl",
  "University Hospital of Patras": "el",
  "Psychiatric Clinic BJS": "sl",
  "University Psichiatric Clinic Ljubljana": "sl"
}

export const sortFieldMap = {
  [Consts.STUDY_ARM]: "study_id",
  [Consts.GENDER]: "gender",
  [Consts.REG_AGE]: "age",
  [Consts.YEAR_OF_BIRTH]: "year_of_birth",
  [Consts.REGISTRATION_DATE]: "registration_date",
  [Consts.LAST_LOGIN]: "lastLogin",
  [Consts.LAST_LOGIN_DAYS]: "lastLoginDays",
  [Consts.NUMBER_LOGINS]: "numberLogins",
  [Consts.DISEASES_LAST_CHANGE]: "diseaseDate",
  [Consts.LAST_DISEASE_DAYS]: "lastDiseaseDays",
  [Consts.NUMBER_DISEASES]: "numberDiseases",
  [Consts.PGX_LAST_CHANGE]: "pgx_test",
  [Consts.NUMBER_GENES]: "numberGenes",
  [Consts.NUMBER_ACTIONABLE_GENES]: "numberActionableGenes",
  [Consts.MED_PLAN_LAST_CHANGE]: "last_prescription",
  [Consts.NUMBER_DRUGS_INITIAL]: "drugsNumberInitial",
  [Consts.NUMBER_DRUGS]: "drugsNumber",
  [Consts.NUMBER_NEW_ADDED_DRUGS]: "newAddedDrugsNumber",
  [Consts.NUMBER_DELETED_DRUGS]: "deletedDrugsNumber",
  [Consts.NUMBER_MED_PLAN_CHANGES]: "changedMedPlanNumber",
  [Consts.NUMBER_DDIS]: "numberDdis",
  [Consts.NUMBER_DGIS]: "numberDgis",
  [Consts.NUMBER_DDGIS]: "ddgiDrugsNumber",
  [Consts.INCREASED_RISK_LESS_10]: "sortedRiskNumbers.diffs.less10",
  [Consts.INCREASED_RISK_FROM_10_TO_20]: "sortedRiskNumbers.diffs.from10to20",
  [Consts.INCREASED_RISK_FROM_20_TO_30]: "sortedRiskNumbers.diffs.from20to30",
  [Consts.INCREASED_RISK_FROM_30_TO_40]: "sortedRiskNumbers.diffs.from30to40",
  [Consts.INCREASED_RISK_FROM_40_TO_50]: "sortedRiskNumbers.diffs.from40to50",
  [Consts.INCREASED_RISK_GREATER_50]: "sortedRiskNumbers.diffs.greater50",
  [Consts.COMBINED_RISK_LESS_10]: "sortedRiskNumbers.totals.less10",
  [Consts.COMBINED_RISK_FROM_10_TO_20]: "sortedRiskNumbers.totals.from10to20",
  [Consts.COMBINED_RISK_FROM_20_TO_30]: "sortedRiskNumbers.totals.from20to30",
  [Consts.COMBINED_RISK_FROM_30_TO_40]: "sortedRiskNumbers.totals.from30to40",
  [Consts.COMBINED_RISK_FROM_40_TO_50]: "sortedRiskNumbers.totals.from40to50",
  [Consts.COMBINED_RISK_GREATER_50]: "sortedRiskNumbers.totals.greater50",
  [Consts.NUMBER_PDMS]: "numberPdms",
  [Consts.SYMPTOMS_LAST_CHANGE]: "last_symptom",
  [Consts.NUMBER_SYMPTOMS]: "numberSymptoms",
  [Consts.NUMBER_DIFF_SYMPTOMS]: "numberDiffSymptoms",
  [Consts.NUMBER_OTHER_SYMPTOMS]: "numberOtherSymptoms",
  [Consts.LAB_TESTS_LAST_CHANGE]: "last_lab_test",
  [Consts.NUMBER_LAB_TESTS]: "numberLabTests",
  [Consts.MEASUREMENTS_LAST_CHANGE]: "last_measurement",
  [Consts.LAST_MEASUREMENT_DAYS]: "lastMeasurementDays",
  [Consts.NUMBER_MEASUREMENTS]: "numberMeasurements",
};

export const statColumns = [
  Consts.PATIENT,
  Consts.STUDY_ARM,
  Consts.GENDER,
  Consts.REG_AGE,
  Consts.YEAR_OF_BIRTH,
  Consts.REGISTRATION_DATE,
  Consts.LAST_LOGIN,
  Consts.LAST_LOGIN_DAYS,
  Consts.NUMBER_LOGINS,
  Consts.DISEASES_LAST_CHANGE,
  Consts.LAST_DISEASE_DAYS,
  Consts.NUMBER_DISEASES,
  Consts.PGX_LAST_CHANGE,
  Consts.NUMBER_GENES,
  Consts.NUMBER_ACTIONABLE_GENES,
  Consts.MED_PLAN_LAST_CHANGE,
  Consts.NUMBER_DRUGS_INITIAL,
  Consts.NUMBER_DRUGS,
  Consts.NUMBER_NEW_ADDED_DRUGS,
  Consts.NUMBER_DELETED_DRUGS,
  Consts.NUMBER_MED_PLAN_CHANGES,
  Consts.NUMBER_DDIS,
  Consts.NUMBER_DGIS,
  Consts.NUMBER_DDGIS,
  Consts.INCREASED_RISK_LESS_10,
  Consts.INCREASED_RISK_FROM_10_TO_20,
  Consts.INCREASED_RISK_FROM_20_TO_30,
  Consts.INCREASED_RISK_FROM_30_TO_40,
  Consts.INCREASED_RISK_FROM_40_TO_50,
  Consts.INCREASED_RISK_GREATER_50,
  Consts.COMBINED_RISK_LESS_10,
  Consts.COMBINED_RISK_FROM_10_TO_20,
  Consts.COMBINED_RISK_FROM_20_TO_30,
  Consts.COMBINED_RISK_FROM_30_TO_40,
  Consts.COMBINED_RISK_FROM_40_TO_50,
  Consts.COMBINED_RISK_GREATER_50,
  Consts.NUMBER_PDMS,
  Consts.SYMPTOMS_LAST_CHANGE,
  Consts.NUMBER_SYMPTOMS,
  Consts.NUMBER_DIFF_SYMPTOMS,
  Consts.NUMBER_OTHER_SYMPTOMS,
  Consts.LAB_TESTS_LAST_CHANGE,
  Consts.NUMBER_LAB_TESTS,
  Consts.MEASUREMENTS_LAST_CHANGE,
  Consts.LAST_MEASUREMENT_DAYS,
  Consts.NUMBER_MEASUREMENTS,
  "",
];

export const statisticsRows = [
    {
      key: "min",
      firstColumnLabel: "Min value",
      values: {},
    },
    {
      key: "max",
      firstColumnLabel: "Max value",
      values: {},
    },
    {
      key: "avg",
      firstColumnLabel: "Average value",
      values: {},
    },
    {
      key: "avgActive",
      firstColumnLabel: "Average value (active)",
      values: {},
    },
    {
      key: "deviation",
      firstColumnLabel: "Deviation",
      values: {},
    },
    {
      key: "deviationActive",
      firstColumnLabel: "Deviation (active)",
      values: {},
    }
  ];